<template>
  <div id="app">
    <news v-if="!$root.ingredients" :id="$root.settings.idForSection" />
    <ingredients v-if="$root.ingredients" :id="$root.settings.idForSection" />
  </div>
</template>

<script>
  import news from './components/news.vue'
  import ingredients from './components/ingredients.vue'
  import axios from 'axios'
  export default {
    name: 'App',
    components: {
      news,
      ingredients,
      axios
    }
  }
</script>

<style lang="scss">
  div#frontpageNewsletter {
    width: 84%;
    margin: 0 auto;
    margin-top: -2px;
    margin-bottom:20px;
    .animationContainer {
      width: 93%;
      vertical-align: top;
      display: block;
      text-align: center;
      margin: 17px;
      margin-bottom: 41px;
    }
    &>div:nth-child(1) {
      width: 100%;
      display: inline-block;
    }
    &>div.animationContainer>div:nth-child(1) {
      width: 100%;
      max-width: 453px;
    }
    #Layer_1 {
      width: 100%;
      margin-top: -60px;
      margin-left: -19px;
      padding-bottom: 0;
    }
    &>div>div:nth-child(2) {
      vertical-align: top;
      margin: 0 auto;
      display: block;
      text-align: center;
      width: 100%;
    }
    .frontpageNewsletterFormContainer {
      width: 85%;
      height: auto;
      margin-bottom: 43px;
    }
    #ID_newsletter_signup {
      display: block;
    }
    .errorMark {
      margin-left: 186px;
    }
  }
</style>